<button mat-mini-fab aria-label="Notification history"
  (menuOpened)="refresh()"
  [matMenuTriggerFor]="menu" class="notification-trigger">
  <mat-icon>notifications</mat-icon>
  @if (items().length) {
    <span class="badge">{{ items().length }}</span>
  }
</button>

<mat-menu #menu="matMenu" xPosition="after" [overlapTrigger]="false">
  <div class="menu-header">
    <span class="title">Notifications</span>
    <button mat-icon-button aria-label="Clear notifications" (click)="clear($event)">
      <mat-icon>delete</mat-icon>
    </button>
  </div>

  <mat-divider></mat-divider>

  @if (items().length > 0) {
    <div class="list-wrap">
      <div class="table-container">
        <table mat-table [dataSource]="items()" class="mat-elevation-z1 notification-table" role="table">
          <!-- Icon Column -->
          <ng-container matColumnDef="icon">
            <td mat-cell *matCellDef="let it">
              <mat-icon class="row-icon">{{ iconFor(it.type) }}</mat-icon>
            </td>
          </ng-container>
          <!-- Message Column -->
          <ng-container matColumnDef="message">
            <td mat-cell *matCellDef="let it">
              <div class="item-body">
                <div class="message">{{ it.message }}</div>
                <div class="time">{{ it.timestamp | date:'short' }}</div>
              </div>
            </td>
          </ng-container>
          <tr mat-row *matRowDef="let row; columns: ['icon','message'];"></tr>
        </table>
      </div>
    </div>
  } @else {
    <div class="empty">No notifications</div>
  }

</mat-menu>
